import type { Mission } from '../missions.ts'

export const usps: Mission = {
  id: "usps",
  name: "United States Postal Service",
  short: "USPS",
  call: "Delivery",
  kind: "independent",
  url: "https://www.usps.com/",
  established: 1971,
  palette: {
    primary: "#004b87",
    secondary: "#da291c",
    accent: "#e7aa21",
  },
  colorSource: {
    kind: "site",
    url: "https://about.usps.com/",
  },
  motif: "envelope",
  mission: {
    text: "To serve the American people and, through the universal service obligation, bind our nation together by maintaining and operating our unique, vital and resilient infrastructure.",
    url: "https://about.usps.com/who/profile/",
  },
  fact: {
    text: "The Post Office Act of 1792 made the postal service a permanent fixture of the federal government.",
    url: "https://about.usps.com/who/profile/",
  },
  seal: {
    file: "public/seals/usps.svg",
    source: "https://commons.wikimedia.org/wiki/File:United_States_Postal_Service_logo_(1970-1993).svg",
  },
  logo: {
    file: "public/logos/usps.svg",
    source: "https://commons.wikimedia.org/wiki/File:USPS_-_Color_Logo.svg",
  },
  identifier: {
    about: "https://about.usps.com/",
    accessibility: "https://about.usps.com/who/legal/accessibility-statement/welcome.htm",
    foia: "https://about.usps.com/who/legal/foia/",
    noFear: "https://about.usps.com/who/legal/no-fear-act/",
    oig: "https://www.uspsoig.gov/",
    performance: "https://about.usps.com/what/strategic-plans/",
    privacy: "https://about.usps.com/who/legal/privacy-policy/welcome.htm",
  },
  media: {
    photos: [
      {
        file: "/media/usps-jeep-mail-truck.jpg",
        small: "/media/usps-jeep-mail-truck-sm.jpg",
        alt: "White postal delivery jeep with red and blue stripes parked on grass",
        title: "A USPS mail delivery vehicle made by Jeep",
        creator: "United States Postal Service",
        source: "https://commons.wikimedia.org/wiki/File:JeepMailTruck.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/usps-parcel-post.jpg",
        small: "/media/usps-parcel-post-sm.jpg",
        alt: "A postal clerk sorting packages on wooden parcel racks at a small-town post office",
        title: "Parcel post racks at the post office at Hermiston, Oregon",
        creator: "Russell Lee, Farm Security Administration",
        source: "https://www.loc.gov/pictures/item/2017816011/",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
